/**
 *
 */

class NomiPickup {

	constructor(resultMap, isEquals) {

		this._resultMap = resultMap;

		this._keyArr = this._setKeyArr( resultMap );


		this._typeBooArr = [ true, false ];
		this.typeStr = [ 'B', 'S' ];
		this._pickupBooArr = [ true, false, false, false, false ];
		this.pickNum = [ 1, 2, 3, 5, 10, 20 ];

		this._btStyle1 = {   trueBg: '#333377',  falseBg: '#fcfcfc', trueColor: '#ffffff',   falseColor: '#222222' };


		//let isEquals = this._isEqualsResultMap( resultMap, resultMapStrage );
		if(isEquals) {
			let pickupState = StorageOperator.getStorageData('session', 'pickup-state');
			if(pickupState) {
				this._typeBooArr = pickupState.type;
				this._pickupBooArr = pickupState.pick;
				this._setStragePickupTableText(pickupState.text);
			}else {
				this._setPickupTableText();
			};
		}else {
			this._setPickupTableText();
		};

		this._allAddEvent();

		

		//
		
	};

	_isEqualsResultMap( map1, map2 ) {

		let boo = true;
		if(map2) {
			let arrKey1 = [];
			for(let key of map1.keys()) {  arrKey1.push(key);  };
			let arrKey2 = [];
			for(let key of map2.keys()) {  arrKey2.push(key);  };
			
			if(arrKey1.length===arrKey2.length) {
				for(let i=0, n=arrKey1.length; i<n; i++) {
					if(arrKey1[i]!==arrKey2[i]) {  boo = false;  };
				};
			}else {
				boo = false;
			};
		}else {
			boo = false;
		};
		return boo;
	};



	_setKeyArr(map) {
		let arr = [];
		for(let key of map.keys()) {   arr.push(key);   };
		return arr;
	};



	_allAddEvent() {
		NomiPickup.setElementEvent( 'typeB', 'click', () => this.typeBtClick(0), false );
		NomiPickup.setElementEvent( 'typeS', 'click', () => this.typeBtClick(1), false );
		this._typeBtStyle();

		for(let i=0, n=this.pickNum.length; i<n; i++) {
			NomiPickup.setElementEvent( 'num'+this.pickNum[i], 'click', () => this.pickNumClick( i ), false );
		};
		this._pickNumBtStyle();

	};




	typeBtClick(val) {

		MyUtility.setFillArray(this._typeBooArr, false);
		this._typeBooArr[val] = true;
		this._typeBtStyle();
		this._setPickupTableText();
	};

	_typeBtStyle() {
		this._btStyle( this._typeBooArr, 'type', this.typeStr, this._btStyle1);
	};


	//
	pickNumClick(val) {

		MyUtility.setFillArray(this._pickupBooArr, false);
		this._pickupBooArr[val] = true;
		this._pickNumBtStyle();
		this._setPickupTableText();
	};

	_pickNumBtStyle() {
		this._btStyle( this._pickupBooArr, 'num', this.pickNum, this._btStyle1);
	};

	_btStyle(booArray, idStr, idStrArray, btStyle) {
		let bg, color;
		for(let i=0, n=booArray.length; i<n; i++) {
			bg = booArray[i] ? btStyle.trueBg: btStyle.falseBg;
			color = booArray[i] ? btStyle.trueColor: btStyle.falseColor;
			let style = document.getElementById( idStr+idStrArray[i] ).style;
			style.background = bg;
			style.color = color;
		};
	};


	_setStragePickupTableText(textArray) {

		//let text = MyUtility.arrayToString( textArray );

		this._setTableText( 'pickResult', textArray);
		//NomiPickup.setElementText( 'pickResult', text );
	};

	_setPickupTableText() {

		this._textArray = this._pickupResult();
		//let text = MyUtility.arrayToString( this._textArray );

		this._setTableText( 'pickResult', this._textArray);
		//NomiPickup.setElementText( 'pickResult', text );

		this._setPickupState();
	};


	_pickupResult() {

		let pickInd = this._pickupBooArr.findIndex((val)=> val);
		let count = (this._keyArr.length < this.pickNum[pickInd]) ?   this._keyArr.length :  this.pickNum[pickInd];

		let resultArr = [];
		if(this._typeBooArr[0]) {

			resultArr = MyUtility.randomPickupArray( this._keyArr, count );
		}else {
			let pickKeyArr = MyUtility.randomPickupArray( this._keyArr, count );
			for(let i=0, n=pickKeyArr.length; i<n; i++) {
				let valArr = this._resultMap.get(pickKeyArr[i]);
				resultArr.push( MyUtility.randomPickupArray( valArr, 1)[0] );
			};
		};
		return resultArr;
	};



	_setTableText(idStr, array) {

		let td = document.getElementById( idStr );
		let chN = td.childNodes;
		for(let i=0, n=chN.length; i<n; i++) {
			td.removeChild(td.lastChild);
		};

		for(let i=0, n=array.length; i<n; i++) {
			let sp = '';
			if(i<n-1) {   sp = ', ';   }
			let valA = document.createElement( 'a' );
			valA.appendChild( document.createTextNode( array[i] ) );

			let nb34 = 'nb'+array[i].length;
			let text = this._arraySortText( array[i] );
			valA.href = '../numb-box/'+nb34+'/'+nb34+'-box-'+text+'.html';
			td.appendChild( valA );
			td.appendChild( document.createTextNode( sp ) );
		};
	};
	_arraySortText(val) {
		let arr = [];
		for(let i=0, n=val.length; i<n; i++) {
			arr.push( Number(val.charAt(i)) );
		};
		Array.sort(arr);
        let text = '';
        for(var i=0, n=arr.length; i<n; i++) {
            text += arr[i];
		};
		return text;
	};



	_setPickupState() {

		let pickupObj = {  type: this._typeBooArr, pick: this._pickupBooArr, text: this._textArray };

		let boo = [true, true];
		try {
			boo = StorageOperator.setStorageData( 'session', 'pickup-state', pickupObj );

		}catch(exeption) {
			alert('お使いのブラウザでは、本サイトは正常に動作しない可能性があります');
		};

		return boo[0];
	};

	//
	//

	static setElementStyle( idStr, targetStr, value ) {
		return document.getElementById( idStr ).style[targetStr] = value;
	};

	//  ノードへ  text 記入
	static setElementText( idStr, text ) {
		document.getElementById( idStr ).textContent = text;
	};

	//  add event
	static setElementEvent( idStr, eventStr, func, boo ) {
		document.getElementById( idStr ).addEventListener( eventStr, func, boo);
	};

};  //  classEnd


